import axios from "axios";
import router from "../router";
import { Message, MessageBox } from "element-ui";
const service = axios.create({
  baseURL:process.env.VUE_APP_BASE_API,
  timeout: 5000,
  headers:{
    "Content-Type":"application/json"
  }
});
service.interceptors.response.use(
  (response) => {
    if(response.data.code==200){
      return response.data
    }else if(response.data.code==401){
      Message({
        type:'error',
        message:'token登录失效，请重新登录！'
      })
    }else if(response.data.code==500){
      Message({
        type:'error',
        message: response.data.msg|| '请求数据接口报错，重试'
      })
    }
  },
  (error) => {
    Message.error(error | "Error");
    return Promise.reject(error);
  }
);

// 封装get
service.$get = (url, data = {}) => {
  return service.get(url, { params: data });
};
// 封装post
service.$post = (url, data = {}) => {
  return service.post(url,data)
};
//封装delete
 service.$delete = (url)=>{
  return service.delete(url)
 }
 //封装put
 service.$put = (url, data = {}) => {
  return service.put(url,data)
};

export default service;